
const sendServerLogging = async (responseData) =>  {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_LOGGING_API_URL}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(responseData),
      }
      
    );
  } catch (err) {
    console.log("Error sending server logging:", err);
  }
}

export default sendServerLogging; 
